"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EllipseChevronLeftIcon24 = void 0;
var react_1 = __importDefault(require("react"));
var build_svg_icon_1 = require("../../build-svg-icon");
exports.EllipseChevronLeftIcon24 = (0, build_svg_icon_1.buildSvgIcon)(react_1.default.createElement('svg', {
    width: '24',
    height: '25',
    viewBox: '0 0 24 25',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
}, react_1.default.createElement('circle', {
    opacity: '0.9',
    cx: '12',
    cy: '12',
    r: '12',
    transform: 'matrix(-1 0 0 1 24 0.75)',
    fill: '#282827',
}), react_1.default.createElement('path', {
    d: 'M13.4988 19.1812C14.051 19.7729 14.9475 19.7729 15.4997 19.1812C16.0514 18.5895 16.0516 17.6302 15.4997 17.0386L11.4988 12.7525L15.5007 8.4644C16.0528 7.87266 16.0519 6.91349 15.4997 6.32182C14.9476 5.73027 14.053 5.72957 13.5007 6.32085L8.50072 11.6783C8.32187 11.8699 8.20143 12.1005 8.13842 12.3443C8.00555 12.854 8.12473 13.4238 8.49877 13.8248L13.4988 19.1812Z',
    fill: 'white',
})), 'EllipseChevronLeftIcon24', { viewBox: '0 0 24 25' });
exports.default = exports.EllipseChevronLeftIcon24;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRWxsaXBzZUNoZXZyb25MZWZ0SWNvbjI0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vZGVzaWduLXN5c3RlbS1pY29ucy91aS1pY29ucy8yNC9FbGxpcHNlQ2hldnJvbkxlZnRJY29uMjQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLGdEQUEwQjtBQUMxQix1REFBb0Q7QUFFdkMsUUFBQSx3QkFBd0IsR0FBRyxJQUFBLDZCQUFZLEVBQ2xELGVBQUssQ0FBQyxhQUFhLENBQ2pCLEtBQUssRUFDTDtJQUNFLEtBQUssRUFBRSxJQUFJO0lBQ1gsTUFBTSxFQUFFLElBQUk7SUFDWixPQUFPLEVBQUUsV0FBVztJQUNwQixJQUFJLEVBQUUsTUFBTTtJQUNaLEtBQUssRUFBRSw0QkFBNEI7Q0FDcEMsRUFDRCxlQUFLLENBQUMsYUFBYSxDQUFDLFFBQVEsRUFBRTtJQUM1QixPQUFPLEVBQUUsS0FBSztJQUNkLEVBQUUsRUFBRSxJQUFJO0lBQ1IsRUFBRSxFQUFFLElBQUk7SUFDUixDQUFDLEVBQUUsSUFBSTtJQUNQLFNBQVMsRUFBRSwwQkFBMEI7SUFDckMsSUFBSSxFQUFFLFNBQVM7Q0FDaEIsQ0FBQyxFQUNGLGVBQUssQ0FBQyxhQUFhLENBQUMsTUFBTSxFQUFFO0lBQzFCLENBQUMsRUFBRSwrV0FBK1c7SUFDbFgsSUFBSSxFQUFFLE9BQU87Q0FDZCxDQUFDLENBQ0gsRUFDRCwwQkFBMEIsRUFDMUIsRUFBRSxPQUFPLEVBQUUsV0FBVyxFQUFFLENBQ3pCLENBQUM7QUFDRixrQkFBZSxnQ0FBd0IsQ0FBQyJ9


//////////////////
// WEBPACK FOOTER
// ./node_modules/@angi/icons/design-system-icons/ui-icons/24/EllipseChevronLeftIcon24.js
// module id = 6583
// module chunks = 6